export const GMAIL_URL = 'https://mail.google.com/mail/u/0/';
